/**
 * @desc 审核
 */
import { ApplyAuditForm } from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type AuditAuctionApplyParameter = ApplyAuditForm

const method = 'PUT'
const url = '/trade/operation/apply/auction/audit'

export const auditAuctionApplyApi = (
  data?: AuditAuctionApplyParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<any>({
    method,
    url,
    data,
    ...config
  })
}

auditAuctionApplyApi.method = method
auditAuctionApplyApi.url = url
